import { render, staticRenderFns } from "./V2WishlistCardForBrand.vue?vue&type=template&id=58b28614&scoped=true&"
import script from "./V2WishlistCardForBrand.vue?vue&type=script&lang=js&"
export * from "./V2WishlistCardForBrand.vue?vue&type=script&lang=js&"
import style0 from "./V2WishlistCardForBrand.vue?vue&type=style&index=0&id=58b28614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b28614",
  null
  
)

export default component.exports